import {
  ROLE_ADMIN_USER,
  ROLE_COORDINATOR,
  ROLE_CRUISE_COORDINATOR,
  ROLE_EMPLOYEE_USER,
  ROLE_EXPERIENCES_COORDINATOR,
  ROLE_ICS_STORE_TEAM,
  ROLE_TOUR_COORDINATOR,
} from '~/consts/roles';

const allowedRoles = [
  ROLE_ADMIN_USER,
  ROLE_EMPLOYEE_USER,
  ROLE_COORDINATOR,
  ROLE_EXPERIENCES_COORDINATOR,
  ROLE_ICS_STORE_TEAM,
  ROLE_CRUISE_COORDINATOR,
  ROLE_TOUR_COORDINATOR,
];

export function validateAdminRole(account: { roles?: Array<string> } | null | undefined) {
  if (!account?.roles?.some((role) => allowedRoles.includes(role))) {
    return new Error(`You don't have the permissions for this operation`);
  }

  return null;
}
